import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';

import App from './App/App';
import store from './store/store';
import { logout, refreshToken, setIsRefreshing, setLastActive, setLastRefreshed } from './store/actions/auth';
import { LAST_ACTIVE_THRESHOLD } from './constants';

// add token to header for all requests, check if need to refresh token
axios.interceptors.request.use((request) => {
  const { isRefreshing } = store.getState().auth;
  const { token } = store.getState().auth;
  if (!isRefreshing) {
    const { lastActive, lastRefreshed } = store.getState().auth;
    const now = new Date();
    const refreshedDiff = lastRefreshed === null ? 0 : now - lastRefreshed;
    const activeDiff = lastActive === null ? 0 : now - lastActive;
    if (refreshedDiff >= LAST_ACTIVE_THRESHOLD && activeDiff <= LAST_ACTIVE_THRESHOLD) {
      store.dispatch(setIsRefreshing(true));
      store.dispatch(refreshToken(token));
    }
    if (lastRefreshed === null) {
      store.dispatch(setLastRefreshed(new Date()));
    }
    store.dispatch(setLastActive(new Date()));
  }
  if (token && !request.url.includes('api-token')) {
    request.headers.Authorization = `JWT ${token}`;
  }
  return request;
});

// check for 401 and logout
axios.interceptors.response.use(null, (error) => {
  if (error.response.status === 401) {
    store.dispatch(logout());
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }
  return Promise.reject(error);
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
